import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink, RouterModule, Routes } from '@angular/router';
import { NgxPrintDirective } from 'ngx-print';
import { Orders } from './orders';
import { ActionDialog } from './action-dialog/action-dialog';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog';

const routes: Routes = [{ path: '', component: Orders }];

@NgModule({
  declarations: [Orders, ActionDialog],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    NgxPrintDirective,
    AlertDialogComponent,
    RouterLink,
  ],
})
export class OrdersModule {}
